export default function FernL() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 492 360">
      <path
        fill="#008737"
        d="M420.235 283.636 491.092 0C125.907-.001.546 354.545.546 354.545l92.658-92.727L98.654 360l38.154-152.727L158.611 360l27.252-196.364 32.703 180 38.98-204.195 20.976 182.377 62.904-224.337L349.378 300l46.553-218.883 24.304 202.519Z"
      />
    </svg>
  );
}
